import React, { useEffect, useMemo, useRef, useState } from "react";
import "../SellerrRegister/SellerrRegister.css";
import registerbg from "../../assets/register-bg.png";
import logo from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";

import {
  defaultCountries,
  parseCountry,
  FlagImage,
} from "react-international-phone";
import "react-international-phone/style.css";

export default function SellerrRegister() {
  const navigate = useNavigate();

  const countries = useMemo(
    () => defaultCountries.map(parseCountry),
    []
  );

  const [isOpen, setIsOpen] = useState(false);
  const [selectedIso2, setSelectedIso2] = useState("eg");
  const dropdownRef = useRef(null);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [code, setCode] = useState("+20");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [area, setArea] = useState("");
  const [address, setAddress] = useState("");
  const [referralCode, setReferralCode] = useState("");

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    const current = countries.find((c) => c.iso2 === selectedIso2);
    if (current) setCode(`+${current.dialCode}`);
  }, [selectedIso2, countries]);

  const validate = () => {
    const temp = {};

    if (!username.trim()) {
      temp.username = "اسم المستخدم مطلوب";
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      temp.email = "البريد الإلكتروني مطلوب";
    } else if (!emailPattern.test(email.trim())) {
      temp.email = "البريد الإلكتروني غير صالح";
    }

    if (!country.trim()) {
      temp.country = "الدولة مطلوبة";
    }

    if (!area.trim()) {
      temp.area = "المدينة / المحافظة مطلوبة";
    }

    if (!address.trim()) {
      temp.address = "العنوان مطلوب";
    }

    if (!phone.trim()) {
      temp.phone = "رقم الجوال مطلوب";
    } else if (!/^\d+$/.test(phone.trim())) {
      temp.phone = "رقم الجوال يجب أن يحتوي على أرقام فقط";
    } else if (phone.trim().length < 7 || phone.trim().length > 12) {
      temp.phone = "رقم الجوال غير صحيح";
    }

    if (!password.trim()) {
      temp.password = "كلمة المرور مطلوبة";
    } else if (password.trim().length < 6) {
      temp.password = "يجب ألا تقل كلمة المرور عن 6 أحرف";
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleFieldChange = (field, value) => {
  let error = "";

  if (field === "username" && !value.trim()) {
    error = "اسم المستخدم مطلوب";
  }

  if (field === "email") {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value.trim()) {
      error = "البريد الإلكتروني مطلوب";
    } else if (!emailPattern.test(value.trim())) {
      error = "البريد الإلكتروني غير صالح";
    }
  }

  if (field === "phone") {
    if (!value.trim()) {
      error = "رقم الجوال مطلوب";
    } else if (!/^\d+$/.test(value.trim())) {
      error = "أرقام فقط";
    } else if (value.length < 7 || value.length > 12) {
      error = "رقم غير صحيح";
    }
  }

  if (field === "password") {
    if (!value.trim()) {
      error = "كلمة المرور مطلوبة";
    } else if (value.length < 6) {
      error = "لا تقل عن 6 أحرف";
    }
  }

  if (field === "country" && !value.trim()) {
    error = "الدولة مطلوبة";
  }

  if (field === "area" && !value.trim()) {
    error = "المدينة مطلوبة";
  }

  if (field === "address" && !value.trim()) {
    error = "العنوان مطلوب";
  }

  setErrors((prev) => ({
    ...prev,
    [field]: error,
  }));
};
  const handleNext = () => {
    if (!validate()) return;

    const step1Data = {
      username: username.trim(),
      email: email.trim().toLowerCase(),
      country: country.trim(),
      code,
      phone: phone.trim(),
      password,
      area: area.trim(),
      address: address.trim(),
      referralCode: referralCode.trim(),
      selectedIso2,
    };

    localStorage.setItem("sellerRegisterStep1", JSON.stringify(step1Data));
    navigate("/seller/sellerreg2");
  };

  return (
    <div className="sellerregisteration">
      <div className="container-fluid">
        <div className="row">
          <div className="image col-12 col-md-6 p-0">
            <img src={registerbg} alt="register" className="login-image" />
          </div>

          <div className="form col-12 col-md-6 d-flex flex-column text-end">
            <div className="mb-4 text-center">
              <img className="sellerreglogo mb-3" src={logo} alt="logo" />
            </div>

            <form onSubmit={(e) => e.preventDefault()}>
              <label>اسم المحل / البائع</label>
              <input
                className={`form-control ${errors.username ? "" : ""}`}
                value={username}
                placeholder="الاسم"
                onChange={(e) => {
                  setUsername(e.target.value);
                  // setErrors((prev) => ({ ...prev, username: "" }));
                   handleFieldChange("username", e.target.value);
                }}
              />
             
              {errors.username && (
                <small className="text-danger d-block pb-2">{errors.username}</small>
              )}

              <label className="">رقم الجوال</label>

              <div className="regphone-row">
                <div className="code-dropdown" ref={dropdownRef}>
                  <button
                    type="button"
                    className="code-dropdown-btn"
                    onClick={() => setIsOpen((v) => !v)}
                  >
                    <span className="code-flag">
                      <FlagImage iso2={selectedIso2} />
                    </span>

                    <span className="code-dial">{code}</span>

                    <span className="code-arrow">▾</span>
                  </button>

                  {isOpen && (
                    <div className="code-dropdown-menu">
                      {countries.map((c) => (
                        <button
                          type="button"
                          key={c.iso2}
                          className="code-item"
                          onClick={() => {
                            setSelectedIso2(c.iso2);
                            setIsOpen(false);
                          }}
                        >
                          <span className="code-flag">
                            <FlagImage iso2={c.iso2} />
                          </span>
                          <span className="code-dial">+{c.dialCode}</span>
                          <span className="code-name">{c.name}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <input
                  className={`phone-number-input text-end ${
                    errors.phone ? "" : ""
                  }`}
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setErrors((prev) => ({ ...prev, phone: "" }));
                     handleFieldChange("phone", e.target.value);
                  }}
                  placeholder="ادخل رقم الجوال"
                  inputMode="numeric"
                  dir="rtl"
                />
              </div>

              {errors.phone && (
                <small className="text-danger d-block pb-1">{errors.phone}</small>
              )}


              <label className="pt-2">البريد الإلكتروني</label>
              <input
                className={`form-control ${errors.email ? "" : ""}`}
                value={email}
                placeholder="example@email.com"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors((prev) => ({ ...prev, email: "" }));
                   handleFieldChange("email", e.target.value);
                }}
              />
              {errors.email && (
                <small className="text-danger d-block pb-1">{errors.email}</small>
              )}


              <label className="pt-2">كلمة المرور</label>

              <div className="special-password-box">
                <input
                  type={showPassword ? "text" : "password"}
                  className={`special-password-input ${
                    errors.password ? "" : ""
                  }`}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, password: "" }));
                  }}
                  placeholder="ادخل كلمة المرور"
                />
                <i
                  className={`fa-regular ${
                    showPassword ? "fa-eye" : "fa-eye-slash"
                  } special-pass-icon`}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>

              {errors.password && (
                <small className="text-danger d-block pb-1">{errors.password}</small>
              )}
 

              <label className="pt-2 pb-2">كود المسوق (اختياري)</label>
              <input
                className="form-control mb-4"
                value={referralCode}
                placeholder="####"
                onChange={(e) => setReferralCode(e.target.value)}
              />

              <div className="row">
                <div className="col-md-6 ">
                  <label>الدولة</label>

                  <input
                    type="text"
                    className={`form-control ${
                      errors.country ? "" : ""
                    }`}
                    placeholder="اسم الدولة"
                    value={country}
                    onChange={(e) => {
                      setCountry(e.target.value);
                      setErrors((prev) => ({ ...prev, country: "" }));
                    }}
                  />

                  {errors.country && (
                    <small className="text-danger d-block pb-1">{errors.country}</small>
                  )}
                </div>

                <div className="col-md-6 ">
                  <label>المدينة / المحافظة</label>

                  <input
                    type="text"
                    className={`form-control ${errors.area ? "" : ""}`}
                    placeholder="اسم المدينة"
                    value={area}
                    onChange={(e) => {
                      setArea(e.target.value);
                      setErrors((prev) => ({ ...prev, area: "" }));
                    }}
                  />

                  {errors.area && (
                    <small className="text-danger d-block pb-1">{errors.area}</small>
                  )}
                </div>
              </div>

              <label className="pb-3 ">العنوان</label>
              <input
                className={`form-control ${errors.address ? "" : ""}`}
                value={address}
                placeholder="العنوان"
                onChange={(e) => {
                  setAddress(e.target.value);
                  setErrors((prev) => ({ ...prev, address: "" }));
                }}
              />

              {errors.address && (
                <small className="text-danger">{errors.address}</small>
              )}

              <br />

              <button
                type="button"
                className="btn w-100 text-white mt-2"
                onClick={handleNext}
                style={{ backgroundColor: "#1d3a77", borderRadius: "10px" }}
              >
                التالي
              </button>

              <p className="text-center mt-3">
                تملك حساب؟
                <Link
                  className="link"
                  to="/login"
                  style={{ marginRight: "6px" }}
                >
                  تسجيل الدخول
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}